import { ZfIcon, ZfStack, ZfTypography } from '@zafire/react';

type Props = {
  icon?: string;
  title?: string;
  description?: string;
};

export const EmptyStateOverlay = ({ icon = 'library_add', title, description }: Props) => {
  return (
    <ZfStack
      direction="column"
      spacing="small"
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
    >
      <ZfIcon size="extra-extra-large" name={icon} style={{ color: 'var(--fg-color-default-disabled, #A2A5AF)' }} />
      <ZfTypography variant="title-medium" color="muted">
        {title}
      </ZfTypography>
      <ZfTypography variant="body-medium" color="muted">
        {description}
      </ZfTypography>
    </ZfStack>
  );
};
